// extracted by mini-css-extract-plugin
export default {"headerWrapper":"HeaderWrapper_headerWrapper__5q3Zl"};